// Every line the CLI prints goes through here.
//
// The reason is blank lines. Which of them is correct depends on what was printed *before*, and that varies
// with the path taken: `deploy` opens a section straight after its header, or after a login that ran
// mid-command, or after a list of skipped services. Hard-coding a leading `\n` on each of those gets one
// path right and doubles up on another — which is exactly what happened. Tracking whether the last thing
// written ended in a blank line makes `section()` correct on every path without anyone having to reason
// about the order commands happen to run in.

/**
 * Starts false: the first thing printed follows the user's own command line, so a section opening the
 * output does want a blank line above it.
 */
let lastWasBlank = false

function record(text: string): void {
  const lines = text.split('\n')

  lastWasBlank = lines[lines.length - 1].trim() === ''
}

/** A line of normal output. */
export function say(text = ''): void {
  console.log(text)
  record(text)
}

/** A line of error output. Goes to stderr, tracked the same way. */
export function sayError(text: string): void {
  console.error(text)
  record(text)
}

/** A warning. Goes to stderr — it is not part of the result the user might be piping somewhere. */
export function sayWarning(text: string): void {
  console.warn(text)
  record(text)
}

/** A blank line, unless the last thing printed already ended in one. */
export function blankLine(): void {
  if (!lastWasBlank) {
    say('')
  }
}

/** Opens a block: a blank line above it, then the line itself. */
export function section(text: string): void {
  blankLine()
  say(text)
}

/**
 * Tell the tracker that something was written that did not go through here.
 *
 * The prompts are the case: readline writes the question and echoes the answer straight to the terminal, so
 * without this the next `section()` would believe the output still ended in a blank line.
 */
export function markDirty(): void {
  lastWasBlank = false
}
